import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-acfeechart',
  templateUrl: './acfeechart.component.html',
  styleUrls: ['./acfeechart.component.scss'],
  providers:[MasterService,AppGlobals]
})
export class AcfeechartComponent implements OnInit {
  closeResult: string;
  modalOptions:NgbModalOptions;
  modalOptions1:NgbModalOptions;
  private modalRef: NgbModalRef;
  classes:any=[];
  totalsum:any;
  arrfeedet:any=[];
  arrfeesumlist:any=[];
  castecats:any=[];
  subcomb:any=[];
  oprtype:string;
  oprtype1:string;
  filtcatgory:any[];
  arrinstallment:any=[];
  aylist:any[];
  arpayopt:any=[];
  arfeequota:any=[];
  armot:any=[];
  arrcourse:any=[];
  arracchead:any=[];
  objdetacc:any={};
  objdetmain:any={};
  accat:any=[];
  catid:any;
  arradmtype=['NEW','OLD'];

  constructor(private http: HttpClient, private fservice: MasterService,private modalService: NgbModal,private apglobal:AppGlobals) { }

  ngOnInit(): void {
this.masacccat();
   
    this.getacchead();
    this.masclass();
    this.mascourse();
    this.masfeequota();
    this.maspayopts();
    this.masinstalment();
    
  }


  masacccat() {
    debugger
    this.fservice.masacccat()
        .subscribe(
        resultArray => {
            console.log('getacccategory', resultArray);
            this.accat = resultArray;
           this.catid=resultArray[0].accatid;
           this.getacfeechart('selsum',this.catid);
        },
        error => console.log("Error :: " + error)
        )
  }

  masfeequota() {
    this.fservice.masfeequota()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arfeequota = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  maspayopts() {
    this.fservice.maspayopt()
        .subscribe(
        resultArray => {
            console.log('maspayopt', resultArray);
            this.arpayopt = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  mascourse() {
    this.fservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('arcourse', resultArray);
            this.arrcourse = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  masclass() {
    this.fservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }    

  masinstalment() {
    this.fservice.getinstallment()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrinstallment = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }  
  getacfeechart(oprtype,sertxt) {
    debugger;
    this.fservice.getacfeechart(oprtype,sertxt)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrfeesumlist = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }   

  getacfeechartdetail(objdata) {
    this.fservice.getacfeechartdet(objdata)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrfeedet = resultArray;

            this.totalsum=resultArray.reduce((sum, el) => sum += parseInt(el.feeamt), 0);
           
        },
        error => console.log("Error :: " + error)
        )
  } 

  getacchead() {
    this.fservice.getacchead('Active')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arracchead = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  } 
  
  binddefaultfilters()
  {
    
  }
  
  openmdldetmain(content,objdata,cmd) {

    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.objdetmain.inid='1';
      this.objdetmain.insid='1';
      this.objdetmain.clid='1';
      this.objdetmain.crid='1';
      this.objdetmain.feqtid='0';
      this.objdetmain.payoptid='1';
      this.objdetmain.admtype='NEW';
      this.getacfeechartdetail(this.objdetmain);

    }

    else{
    this.objdetmain=objdata;
    
    this.getacfeechartdetail(objdata);
    }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  openmdldetacc(content,objdata,cmd) {
    
    this.oprtype1=cmd;
    this.objdetacc={}
    if(cmd=='insert')
    {
      this.objdetacc.acid='1';
      this.objdetacc.rid='0';
      this.objdetacc.feeamt='1';
    }

    else if(cmd=='update')
    {
      this.objdetacc=objdata;
    }
    //this.getacfeechartdetail(objdata);
    this.modalOptions1 = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions1);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  savefromdet() {
    this.objdetmain.acid=this.objdetacc.acid;
    this.objdetmain.feeamt=this.objdetacc.feeamt;
    this.objdetmain.rid=this.objdetacc.rid;
    this.objdetmain.oprtype=this.oprtype1;

    console.log('savedetails',this.objdetmain);

    this.fservice.saveacfeechart(this.objdetmain)
    .subscribe(result => {
      alert(result.message);
      
   if(result.status=='success')
   {
     let localmodref=this.modalRef;
   localmodref.close();
   //this.Refreshsummary();
   this.getacfeechartdetail(this.objdetmain);
   
   }
   
   
   else{
   
   
   }
      
   
     
       
   }, error => alert('error in connection')
   );
   
  } 


  delacc(rid) {
    
if(confirm('Are you sure, you want to delete ?'))
{
    this.fservice.delacfeechart(rid)
    .subscribe(result => {
      alert(result.message);
      
   
   this.getacfeechartdetail(this.objdetmain);
   
     
       
   }, error => alert('error in connection')
   );
   
  }
}
}
